<template>
  <v-card class="px-2 pt-10">
    <v-card-title class="headline justify-center">
      {{ title }}
    </v-card-title>

    <v-card-text v-if="caution" style="margin-bottom: 32px;" class="text-center px-10 text-subtitle-1">
      {{ caution }}
    </v-card-text>

    <v-card-text>
      <label for="remarks" class="font-weight-bold">Remarks *</label>
      <v-textarea
        id="remarks"
        v-model="remarks"
        rows="4"
        :placeholder="mode === 'approve' ? 'Tulis deskripsi alasan approve request insert transaction on us' : 'Tulis deskripsi alasan reject request insert transaction on us'"
        outlined
        :style="{ 'font-size': '14px' }"
        :error-messages="errorMessages"
        @blur="checkRemarks"
        @input="handleInput"
      ></v-textarea>
    </v-card-text>

    <v-card-text>
      <div class="d-flex align-start">
        <v-checkbox v-model="isConfirmed" color="primary"></v-checkbox>
        <span>{{ confirmationText }}</span>
      </div>
    </v-card-text>

    <v-card-actions style="padding: 16px;">
      <v-spacer />
      <v-btn dark color="secondary" @click="cancelDialog">Cancel</v-btn>
      <v-btn
        :color="mode === 'approve' ? 'primary' : 'red'"
        @click="confirmDialog"
        :disabled="!isConfirmed || loading || !remarks"
        :loading="loading"
        style="color: #fff;"
      >
        {{ mode === 'approve' ? 'Approve' : 'Reject' }}
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    caution: {
      type: String,
      default: null,
    },
    mode: {
      type: String,
      default: 'approve',
    },
    remark: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      remarks: this.remark,
      isConfirmed: false,
      errorMessages: [],
      confirmationText: `Saya telah memeriksa ulang pengajuan dan saya telah membaca, memahami, dan menyetujui seluruh syarat dan ketentuan yang berlaku terkait dengan proses insert transaction on us.  Saya juga memahami bahwa dengan memberikan konfirmasi ini,
      saya mengizinkan untuk memproses insert transaction on us atas transaksi tersebut sesuai dengan prosedur yang telah ditetapkan.
      Saya bertanggung jawab penuh atas kebenaran data yang saya setujui dan konsekuensi dari setiap kesalahan data tersebut. Saya juga memahami bahwa konfirmasi ini tidak dapat dibatalkan ketika approval transaction on us dilakukan.*`
    };
  },
  watch: {
    remark(newRemark) {
      this.remarks = newRemark;
    },
  },
  methods: {
    
    resetFields() {
      this.remarks = '';
      this.isConfirmed = false;
      this.errorMessages = [];
      this.$emit('update:remark', this.remarks); 
    },
    cancelDialog() {
      this.resetFields();
      this.$emit('closeCancelParent');
    },
    confirmDialog() {
      this.errorMessages = [];

      if (this.isConfirmed && this.remarks) {
        this.$emit('confirmParent');
        this.resetFields();
      } else {
        if (!this.isConfirmed) {
          this.errorMessages.push('Please check the confirmation box.');
        }
        if (!this.remarks) {
          this.errorMessages.push('Remarks required.');
        }
      }
    },
    checkRemarks() {
      if (!this.remarks) {
        this.errorMessages.push('Remarks required.');
      }
    },
    clearErrors() {
      this.errorMessages = this.errorMessages.filter(msg => msg !== 'Remarks required.');
    },
    updateRemark(value) {
      this.remarks = value;
      this.$emit('update:remark', this.remarks);
    },
    handleInput(value) {
      this.clearErrors();
      this.updateRemark(value);
    },
  },
};
</script>

<style>
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
